import { render, staticRenderFns } from "./activityStatistics.vue?vue&type=template&id=2df64566&scoped=true&"
import script from "./activityStatistics.vue?vue&type=script&lang=js&"
export * from "./activityStatistics.vue?vue&type=script&lang=js&"
import style0 from "./activityStatistics.vue?vue&type=style&index=0&id=2df64566&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df64566",
  null
  
)

component.options.__file = "activityStatistics.vue"
export default component.exports